export default function Footer(){
    
    let currentYear = () => {

        var currentTime = new Date();

        return currentTime.getFullYear().toString();
    }
    
    return (
        <footer className="bg-pp-secondary">
                <div>
                    <span className="text-light">ABPN Physician Portal users agree to the ABPN <a className="text-light underline" target="_BLANK" href="https://www.abpn.org/about/policies/">policies</a></span>
                </div>
                <div>
                    <a className="text-light underline" target="_BLANK" href="https://www.abpn.org/terms-of-use/">Terms of Service and Privacy Policy</a>
                </div>
                <div>
                    <span className="text-light">© {currentYear()}, American Board of Psychiatry and Neurology, Inc. All rights reserved.</span>
                </div>
        </footer>
    );

}